import axiosApiClient from "../axios";
import {getBackendUrl} from "../../utils/config";

const PATH = '/actuator/health';

export const checkBackendHealth = async () => {
    try {
        console.log('Checking backend health...');
        const backendUrl = getBackendUrl();
        const fullUrl = `${backendUrl}${PATH}`;
        console.log('Health check URL:', fullUrl);

        // Use direct axios to bypass any interceptor issues
        const response = await fetch(fullUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            signal: AbortSignal.timeout(5000) // 5 second timeout
        });

        console.log('Backend health response status:', response.status);

        // Debug: Log response headers
        const contentType = response.headers.get('content-type');
        console.log('Backend health response content-type:', contentType);

        if (response.ok) {
            // Check if response is JSON by looking at content-type
            if (contentType && (contentType.includes('application/json') || contentType.includes('application/vnd.spring-boot.actuator'))) {
                const data = await response.json();
                console.log('Backend health response data:', data);
                console.log('✅ Backend health check successful - status:', response.status);
                return {
                    isAlive: true,
                    status: response.status,
                    data: data
                };
            } else {
                // Non-JSON response (probably HTML error page)
                const textData = await response.text();
                console.warn('Backend health check returned non-JSON response:', textData.substring(0, 100) + '...');
                return {
                    isAlive: false,
                    status: response.status,
                    message: 'Health endpoint returned HTML instead of JSON - endpoint may not be available'
                };
            }
        } else {
            console.error('Backend health check failed with status:', response.status);
            const textData = await response.text();
            return {
                isAlive: false,
                status: response.status,
                message: `Backend returned error status: ${response.status}`,
                details: textData.substring(0, 200)
            };
        }
    } catch (err) {
        console.error('Backend health check error:', err);
        return {
            isAlive: false,
            status: err.response?.status || 'NETWORK_ERROR',
            message: err.response?.data?.message || err.message || 'Backend is not responding'
        };
    }
};

export const validateToken = async () => {
    try {
        console.log('Validating token using profile endpoint...');
        const response = await axiosApiClient.get('/api/auth/profile', {
            timeout: 5000
        });
        console.log('Token validation response:', response.data);
        return {
            isValid: true,
            data: response.data
        };
    } catch (err) {
        console.error('Token validation error:', err);
        return {
            isValid: false,
            status: err.response?.status || 'NETWORK_ERROR',
            message: err.response?.data?.message || err.message || 'Token validation failed'
        };
    }
}; 